import { createSlice } from '@reduxjs/toolkit';

// Holds only the dashboard filter UI state (hooks-only consumers)
const initialState = {
  currentFilter: 0,
  currentStudentFilter: 0,
};

const dashboardFilterSlice = createSlice({
  name: 'dashboardFilters',
  initialState,
  reducers: {
    setFilter: (state, action) => { state.currentFilter = action.payload; },
    setStudentFilter: (state, action) => { state.currentStudentFilter = action.payload; },
    resetDashboardFilters: () => initialState,
  },
});

export const { setFilter, setStudentFilter, resetDashboardFilters } = dashboardFilterSlice.actions;

export default dashboardFilterSlice.reducer;

